interface GuideMedia {
    label: string;
    url: string;
    mediaType: 'video' | 'image';
}

const ASSET_BASE_URL = 'https://d1pwidzl9kib4u.cloudfront.net';
const PRODUCT_GUIDE_ASSETS_BASE_URL = `${ASSET_BASE_URL}/product/guide-assets`;
const getProductGuideAssetsBaseUrl = (signUpId: string) => {
    return `${PRODUCT_GUIDE_ASSETS_BASE_URL}/${signUpId}`;
};

export const getGuideBioVideoUrls = (
    guideSignUpId: string | null | undefined,
): { mp4Url: string; posterUrl: string } | null => {
    if (guideSignUpId == null || guideSignUpId === '') {
        return null;
    }

    return {
        mp4Url: `${getProductGuideAssetsBaseUrl(guideSignUpId)}/bio_1x1_lq_lc.mp4`,
        posterUrl: `${getProductGuideAssetsBaseUrl(guideSignUpId)}/bio_1x1_poster.jpg`,
    };
};

/** Returns the list of videos and images that we assert are required by the member app to exist in S3 at the specified locations */
export const getRequiredGuideMediaUrls = (
    guideSignUpId: string | null | undefined,
): GuideMedia[] | null => {
    const bioMedia = getGuideBioVideoUrls(guideSignUpId);

    return [
        {
            label: 'Bio MP4',
            url: bioMedia?.mp4Url ?? '',
            mediaType: 'video',
        },
        {
            label: 'Bio Poster',
            url: bioMedia?.posterUrl ?? '',
            mediaType: 'image',
        },
    ];
};
